import { inject, Injectable, NgZone } from '@angular/core';
import { collection, onSnapshot } from 'firebase/firestore';
import { Observable } from 'rxjs';
import { FIRESTORE } from '../core/firebase.tokens';
import { discoverySphereFrom, type DiscoverySphere } from './discovery-sphere.model';

@Injectable({ providedIn: 'root' })
export class DiscoverySphereFirestoreService {
  private readonly firestore = inject(FIRESTORE);
  private readonly zone = inject(NgZone);

  /** Every sphere record: one document per sphere in `discovery_sphere`, absent spheres included. */
  watchSpheres(): Observable<DiscoverySphere[]> {
    return new Observable((subscriber) =>
      onSnapshot(
        collection(this.firestore, 'discovery_sphere'),
        (snapshot) =>
          this.zone.run(() =>
            subscriber.next(
              snapshot.docs.map((item) => discoverySphereFrom(item.id, item.data())),
            ),
          ),
        (error) => this.zone.run(() => subscriber.error(error)),
      ),
    );
  }
}
